import Vue from "vue";
import store from "@/store";

import { syncGetToken } from "@/utils/auth"; // getToken from cookie
import Router from "vue-router";
import signIn from "./login";
// import Config from "./config";

Vue.use(Router);

export const routers = [
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
    },
    component: signIn,
  },
  {
    path: "/",
    redirect: "/",
    meta: {
      title: "新闻智能检索",
    },
    component: (resolve) => require(["./views/home.vue"], resolve),
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          name: "首页",
          index: 0,
        },
        // component: (resolve) => require(["./views/project/AiAnalysis.vue"], resolve)
        component: (resolve) => require(["./views/project/index.vue"], resolve),
      },
      {
        path: "articleDetails/:id",
        name: "articleDetails",
        meta: {
          name: "文章详情",
        },
        component: (resolve) =>
          require(["./views/project/ArticleDetails.vue"], resolve),
      },
    ],
  },
  {
    path: "*",
    component: (resolve) => require(["./views/404.vue"], resolve),
  },
];

export const router = new Router({
  base: "/",
  mode: "history",
  routes: routers,
  linkActiveClass: "active",
});

const whiteList = ["/login", "/auth-redirect"]; // no redirect whitelist
router.beforeEach((to, from, next) => {
  store.commit("SET_VISIBLE", String(to.query.edit) === "true");

  // NProgress.start() // start progress bar
  if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next();
  } else if (store.getters.noAsyncGetToken) {
    store.commit("SET_NOASYNCGETTOKEN", false);
    next();
  } else {
    syncGetToken("FN_REFTOKEN")
      .then((res) => {
        let { token } = res;
        console.log("====");
        if (token) {
          if (to.path === "/login") {
            next({
              path: "/",
            });
            return;
          } else if (to.path === "/404") {
            next();
            return;
          }
          if (store.getters.roles.length === 0) {
            // 判断当前用户是否已拉取完user_info信息
            store
              .dispatch("GetUserInfo")
              .then((data) => {
                // 拉取user_info
                // console.log(store);
                // store
                //   .dispatch("GenerateRoutes", {
                //     templates: store.getters.templates,
                //     routers: data,
                //     name: Config.name,
                //     indexPath: Config.indexPath
                //   })
                //   .then(() => {
                //     // 根据roles权限生成可访问的路由表
                //     router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
                //     next({
                //       ...to,
                //       replace: true
                //     }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                //   });
                store.dispatch("WebStockInit");
              })
              .catch((err) => {
                console.log(err);
                next({
                  path: "/404",
                });
              });
          } else {
            next();
          }
        } else {
          if (
            to.fullPath != null &&
            to.query.searchKey !== undefined &&
            to.query.searchKey !== ""
          ) {
            window.localStorage.setItem("searchKey", to.query.searchKey); //临时写的，登录页传不了参数
          } else {
            window.localStorage.removeItem("searchKey");
          }
          if (
            to.query.date != null &&
            to.query.date !== undefined &&
            to.query.date !== ""
          ) {
            console.log(123);
            window.localStorage.setItem("searchDate", to.query.date); //临时写的，登录页传不了参数
          } else {
            window.localStorage.removeItem("searchDate");
          }
          console.log(to.fullPath, to, to.query.date, "==");
          next({
            path: "/login",
            query: { redirect: to.fullPath },
          });
          console.log(to, "未登入");
        }
      })
      .catch((err) => {
        console.error(err);
        next();
      });
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(() => {
  // NProgress.done() // finish progress bar
});
